import mitt from 'mitt'
import { PopupType } from '~/static/enums/popup'

type ApplicationEvents = {
  'popup:show': {
    type?: PopupType
    text: string
    closeAfter?: number
  }
  'editor:save': undefined
  'editor:saved': undefined
  'editor:save-error': undefined
  'editor:download': {
    width: number
    height: number
    side?: 'client' | 'server'
  }
  'editor:downloaded': undefined
  'editor:clone': undefined
  'editor:chage-size': {
    width: number
    height: number
  }
  'editor:used-browser-feature': undefined
  'cookies:popup': undefined
  'text:open-editor': {
    initialText: string
    callback: (text: string) => void
  }
  'full-panel:open': {
    title: string
    showBackButton: boolean
    showCloseButton: boolean
    freezedHeight?: number
  }
  'full-panel:close': undefined
  'full-panel:closed': undefined
}

export default defineNuxtPlugin(() => {
  const emitter = mitt<ApplicationEvents>()

  return {
    provide: {
      event: emitter.emit,
      listen: emitter.on,
      off: emitter.off,
    },
  }
})
